import React from 'react'

import { Header } from '../../Header'

const VendorsHeader = () => {
  return <Header crumbs={[{ to: '/vendors', value: 'Vendors' }]} />
}

export { VendorsHeader }
